/**
 * WebApp.showAlert / showConfirm / HapticFeedback throw
 * ``WebAppMethodUnsupported`` on old Telegram clients — an unguarded call in
 * an event handler silently kills the tapped action. Degrade to the browser
 * dialogs (or a no-op for haptics) instead.
 */
import WebApp from '@twa-dev/sdk';

export function safeAlert(message: string): void {
  try {
    WebApp.showAlert(message);
  } catch {
    try {
      window.alert(message);
    } catch {
      // no dialog available at all — nothing left to show
    }
  }
}

export function safeConfirm(message: string, callback: (confirmed: boolean) => void): void {
  try {
    WebApp.showConfirm(message, callback);
  } catch {
    callback(window.confirm(message));
  }
}

export function safeHaptic(type: 'error' | 'success' | 'warning'): void {
  try {
    WebApp.HapticFeedback.notificationOccurred(type);
  } catch {
    // haptics unsupported — ignore
  }
}
